import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import { Dialog, Typography, Chip, Box } from '@mui/material';
import * as taskTemplateStyle from 'mui-components/kart/fieldmap/tasktemplates/TaskTemplateStyle';
import MuiTimerTextField from 'components/mui3-forms/MuiTimerTextField';

class TimerModal extends React.Component {
  render() {
    const {intl, isTimerOpen, handleCancelTimerButton, handleHoursChange, formErrors, handleMinutesChange, handleOkTimerButton,
      formState} = this.props;
    return (
      <Dialog onClose={() => { }} open={isTimerOpen} PaperProps={{
        style: {
          backgroundColor: '#E6E9E8',
          borderRadius: "28px",
          width: "312px",
          minWidth: "280px",
          maxWidth: "312px",
          maxHeight: '50vh',
          overflow: 'hidden'
        }
      }}>
        <Box style={taskTemplateStyle.cancelModalBox}>
          <Typography style={taskTemplateStyle.timerModalTitle}>{intl.formatMessage({ id: 'TIME_SPENT' })}</Typography>
        </Box>
        <Box display="flex" justifyContent="center" alignItems="center" mt={2} mb={4}>
          <MuiTimerTextField
            defaultLabel={""}
            fieldName='timerHour'
            autoFocus={true}
            onChange={handleHoursChange}
            helperText="Timer"
            errorHelperText={formErrors['timerHour']}
            defaultValue={formState.timerHour || null}
          />
          <Typography variant="h4" sx={{ 
            mx: 1,
            textAlign: 'center',
            justifyContent: 'center',
            display: 'flex',
            flexDirection: 'column',
            color: '#191C1C',
            fontSize: 57,
            fontFamily: 'Roboto',
            fontWeight: '400',
            wordWrap: 'break-word',
            marginTop: '-20px'
          }}>
            :
          </Typography>
          <MuiTimerTextField
            defaultLabel={""}
            fieldName='timerMinutes'
            autoFocus={false}
            onChange={handleMinutesChange}
            helperText="Minutter"
            errorHelperText={formErrors['timerMinutes']}
            defaultValue={formState.timerMinutes || null}
          />
        </Box>
        <Box style={taskTemplateStyle.timerModalBoxButton}>
          <Chip
            label={intl.formatMessage({ id: 'cancel' })}
            clickable
            style={taskTemplateStyle.cancelButtonStyle}
            sx={{
              backgroundColor: 'transparent',
              '&:hover, &:focus': {
                backgroundColor: 'transparent',
              }
            }}
            disableRipple
            onClick={handleCancelTimerButton}
          />
          <Chip
            label={intl.formatMessage({ id: 'Ok' })}
            clickable
            style={taskTemplateStyle.cancelButtonStyle}
            sx={{
              backgroundColor: 'transparent',
              '&:hover, &:focus': {
                backgroundColor: 'transparent',
              }
            }}
            disableRipple
            onClick={handleOkTimerButton}
            disabled={formErrors.timerHour || formErrors.timerMinutes}
          />
        </Box>
      </Dialog>
    );
  }
}

const mapDispatchToProps = dispatch => ({
});

const mapStateToProps = state => ({
  userDetails: state.userDetails
});

export default injectIntl(
  reduxForm({
    form: 'TimerModal'
  })(connect(mapStateToProps, mapDispatchToProps)(TimerModal))
);
